import { gql } from "@apollo/client";

/**
 * Who documented the scan on a node (IBM-1039). `EffectiveNetworkScan` carries
 * no `userName`, so the IoT gate and an inherited scan in the tab look it up
 * on the source node's own scan. The source may be a node the user cannot
 * read — callers use `errorPolicy: 'all'` and simply omit the name then.
 * `state`/`scanDate` keep the merged `networkScan` cache entry complete.
 * Only sent while REACT_APP_ENABLE_SLA is on.
 */
export const InstalledBaseNodeNetworkScanUser = gql`
    query InstalledBaseNodeNetworkScanUser($id: ID!) {
        installedBaseNode(id: $id) {
            id
            networkScan {
                state
                scanDate
                userName
            }
        }
    }
`;
